module.exports = __webpack_public_path__ + "img/catfood_logo2020.7d145f8c.png";